import React, { useEffect, useState } from "react";
import PeriodicRangeFilter from "../../components/PeriodicRangeFilter";
import AreaChart from "../../components/Charts/AreaChart";
import {
  moduleWiseChartProps,
  speedTimeChartProps,
  vioLationsBreakdownProps,
  unSafeActionsBreakdownProps,
  MrrArrProps,
  ConversionRateProps,
  CltvProps,
  SrrArrProps,
} from "../../components/Charts/ChartConfig";
import BarChart from "../../components/Charts/BarChart";
import ColumnCharts from "../../components/Charts/ColumnCharts";
import Piecharts from "../../components/Charts/Piecharts";
import GeographicalCharts from "../../components/Charts/GeographicalCharts";
import CustomDateRangePicker from "../../components/DateRangePicker";
import RevenueGraph from "./RevenueGraph";
import HeatMapGraph from "./HeatMapGraph";
import UsersChart from "./UsersChart";
import CardsList from "./CardsList";
import RetentionGraph from "./RetentionGraph";
import ChurnGraph from "./ChurnGraph";
import Tableau from "../../components/Tablue/Tableau";
import apiClient from "../../apiClient";
import { FETCH_RETENTION_AND_CHURN_RATE, GET_CARDS_DATA } from "../../apiClient/apiEndpoints";
import { SSO_URL } from "../../env";
import moment from "moment";
import CircularProgress from "@mui/material/CircularProgress";
import { MuiLoader } from "../../Utils/common";
import { CONVERSION_RATE_TYPE } from "../../Constant/constant";

const Overview = () => {
  const [activeRange, setActiveRange] = useState("all");
  const [dateRange, setDateRange] = useState(getFinancialYearRange());
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [retentionRate, setRetentionRate] = useState([]);
  const [churnRate, setChurnRate] = useState([]);
  const [conversionRate, setConversionRate] = useState(ConversionRateProps);
  const [loading, setLoading] = useState(true);
  const [conversionLoading, setConversionLoading] = useState(true);

  const getChartHeight = (defaultHeight) => {
    if (windowWidth <= 1650) return "200px";
    return defaultHeight;
  };

  const getChartHeight2 = (defaultHeight) => {
    if (windowWidth <= 1650) return "150px";
    return defaultHeight;
  };

  const fetchRetionAndChurnRate = async () => {
    try {
      setLoading(true);
      const currDate = moment().toISOString();
      const params = {
        startDate: dateRange ? dateRange[0] : null,
        endDate: dateRange ? (dateRange[1]?.toISOString() > currDate ? currDate : dateRange[1]) : null,
      };
      const response = await apiClient.get(`${SSO_URL}${FETCH_RETENTION_AND_CHURN_RATE}`, { params: params });
      const label = response?.map((e) => e.label);
      const retentionData = [{ name: "", data: response?.map((e) => e.value) }];
      const churnData = [{ name: "", data: response?.map((e) => 100 - Number(e.value)?.toFixed(2)) }];
      setRetentionRate({ categories: label, data: retentionData });
      setChurnRate({ categories: label, data: churnData });
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchTrialConversionRate = async () => {
    try {
      setConversionLoading(true);
      const params = {
        startDate: dateRange ? dateRange[0] : null,
        endDate: dateRange ? dateRange[1] : null,
      };
      const response = await apiClient.get(`${SSO_URL}${GET_CARDS_DATA}/${CONVERSION_RATE_TYPE}`, { params: params });
      const conversionData = [
        { name: "Paid", data: [response?.count?.paid] },
        { name: "Trial", data: [response?.count?.trial] },
      ];
      setConversionRate((prev) => ({ ...prev, data: conversionData }));
      setConversionLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchTrialConversionRate();
    fetchRetionAndChurnRate();
  }, [dateRange]);

  function getFinancialYearRange() {
    const today = moment();
    const currentYear = today.month() >= 3 ? today.year() : today.year() - 1;
    const start = moment(`01-04-${currentYear}`, "DD-MM-YYYY").startOf("day");
    const end = moment(`31-03-${currentYear + 1}`, "DD-MM-YYYY").endOf("day");
    return [start.toDate(), end.toDate()];
  }

  return (
    <div className="overview-page">
      <div className="page-title">
        <h6> Overview </h6>
        <CustomDateRangePicker
          cleanable={false}
          dateRange={dateRange}
          setDateRange={setDateRange}
          disableBeforeDates={false}
        />
      </div>
      <div className="overviewPageContent">
        <div className="stats-here">
          <CardsList dateRange={dateRange} />
        </div>

        <div className="charts-parent">
          <div className="TablueSide">
            <Tableau dateRange={dateRange} />
          </div>
          <div className="dashchartRight">
            <div className="col-md-12">
              <RetentionGraph name="Retention" dateRange={dateRange} data={retentionRate} loading={loading} />
            </div>

            <div className="col-md-12">
              <ChurnGraph name="Churn Graph" dateRange={dateRange} data={churnRate} loading={loading} />
            </div>

            <div className="col-md-12">
              <div className="chart-parent">
                <div className="chat-infos">
                  <h6>Trial Conversion Rate</h6>
                </div>
                {conversionLoading ? (
                  <MuiLoader size={40} message="Fetching data...." />
                ) : (
                  <BarChart horizontalBar={true} {...conversionRate} />
                )}
              </div>
            </div>
          </div>

          {/* <div className="row mt-4">
          <div className="col-md-8">
            <HeatMapGraph dateRange={dateRange} getChartHeight={getChartHeight} />
          </div>
          <div className="col-md-4">
            <div className="chart-parent">
              <div className="chat-infos">
                <h6>Growth Metrics</h6>
                <p>
                  <span>(+100) more</span> in 2024
                </p>
              </div>
              <Piecharts height={getChartHeight2("100%")} type={"donut"} legend={false} />
              <div className="growthmetricsdata d-flex justify-content-between w-100 mb-2">
                <div className="chat-infos">
                  <h6>Retained Users</h6>
                  <h5>2500</h5>
                </div>
                <div className="chat-infos">
                  <h6>Non Retained Users</h6>
                  <h5>500</h5>
                </div>
              </div>
            </div>
        </div>
        </div> */}

          {/* <div className="row mt-4">
          <div className="col-md-6">
            <UsersChart name="Users" dateRange={dateRange} getChartHeight={getChartHeight} />
          </div>

          <div className="col-md-6">
            <ClientChart name="Clients" dateRange={dateRange} getChartHeight={getChartHeight} />
          </div>

          <div className="col-md-6">
            <div className="chart-parent">
              <div className="chat-infos">
                <h6>CLTV(Customer lifetime value)</h6>
                <p>
                  <span>(+100) more</span> in 2024
                </p>
              </div>
              <ColumnCharts height={getChartHeight("325px")} {...CltvProps} />
            </div>
          </div>
          <div className="col-md-3">
            <div className="chart-parent">
              <div className="chat-infos">
                <h6>Geographical insight</h6>
                <p>
                  <span>(+100) more</span> in 2024
                </p>
              </div>
              <GeographicalCharts height={getChartHeight("325px")} />
            </div>
          </div>
          <div className="col-md-3">
            <div className="chart-parent">
              <div className="chat-infos">
                <h6>Growth Metrics</h6>
                <p>
                  <span>(+100) more</span> in 2024
                </p>
              </div>
              <Piecharts height={getChartHeight2("250px")} type={"donut"} legend={false} />
              <div className="growthmetricsdata d-flex justify-content-between w-100 mb-2">
                <div className="chat-infos">
                  <h6>Retained Users</h6>
                  <h5>2500</h5>
                </div>
                <div className="chat-infos">
                  <h6>Non Retained Users</h6>
                  <h5>500</h5>
                </div>
              </div>
            </div>
          </div>
        </div> */}

          {/* <div className="row mt-4">
          <div className="col-md-4">
            <div className="chart-parent">
              <div className="chat-infos">
                <h6>New Subscription</h6>
                <p>
                  <span>(+5) more</span> in 2024
                </p>
              </div>
              <AreaChart height={getChartHeight("250px")} {...SrrArrProps} />
            </div>
          </div>
          <div className="col-md-4">
            <div className="chart-parent">
              <div className="chat-infos">
                <h6>Retention Rate</h6>
                <p>
                  <span>(+5) more</span> in 2024
                </p>
              </div>
              <AreaChart height={getChartHeight("250px")} {...SrrArrProps} />
            </div>
          </div>
          <div className="col-md-4">
            <div className="chart-parent">
              <div className="chat-infos">
                <h6>Churn Rate</h6>
                <p>
                  <span>(+5) more</span> in 2024
                </p>
              </div>
              <AreaChart height={getChartHeight("250px")} {...SrrArrProps} />
            </div>
          </div>
        </div> */}
        </div>
      </div>
    </div>
  );
};

export default Overview;
